import type { CurrencyCode } from '@noths/polaris-dev-ts-types';

import type { CatServiceAPIProductOption } from 'src/services/cat-service-api/types/CatServiceAPIProductOption';
import { getOptionsCostRange } from './getOptionsCostRange';

interface GetMinimumOptionsCostOptions {
  currency: CurrencyCode;
  options: CatServiceAPIProductOption[];
  personalisable: boolean;
}

export const getMinimumOptionsCost = ({
  currency,
  options,
  personalisable,
}: GetMinimumOptionsCostOptions): number => {
  const optionsCostRange = getOptionsCostRange(options, currency);
  const optionsAddCost = options.length > 0 && personalisable && optionsCostRange.minRequired > 0;

  return optionsAddCost ? optionsCostRange.minRequired : 0;
};
